import { TabStyles } from '@tableau/widgets';

import { cssClass, Style, textEllipsis } from '../../../style';


const cssPrefix = 'CardViewDetailsTooltip';

export namespace DetailsTooltipStyles {

  export const Width = 320;

  export const DetailsTooltip = cssClass(cssPrefix, 'details-tooltip', {
    fontWeight: 'normal',
    width: Width,
    paddingTop: 6,
    lineHeight: '14px',
    fontSize: '12px',
    color: TabStyles.Typography.Color.Primary,
  });

  export const EntityName = cssClass(cssPrefix, 'entity-name', {
    lineHeight: '21px',
    fontWeight: 'bold',
    fontSize: '14px',
    maxHeight: '1.5em * 5',
    wordWrap: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: TabStyles.Spacing.LargeSpace
  });

  export const MetadataSection = cssClass(cssPrefix, 'metadata-section', textEllipsis, {
    marginBottom: TabStyles.Spacing.LargeSpace,
    $nest: {
      '&:last-of-type': {
        marginBottom: 0
      }
    }
  });

  export const MetadataSectionWithContentDescription = cssClass(cssPrefix, 'metadata-content-description-section', {
    marginBottom: TabStyles.Spacing.ExtraLargeSpace
  });

  export const MetadataSectionWithCertifierDetails = cssClass(cssPrefix, 'metadata-certifier-details-section', {
    marginTop: TabStyles.Spacing.LargeSpace
  });

  export const MetadataTitle = cssClass(cssPrefix, 'metadata-title', {
    fontWeight: 'bold',
  });

  export const MultiLineTitle = cssClass(cssPrefix, 'metadata-multiline-title', {
    fontWeight: 'bold',
    marginBottom: TabStyles.Spacing.MediumSpace
  });

  export const MetadataRelatedTitle = cssClass(cssPrefix, 'metadata-list-title', {
    fontWeight: 'bold',
    lineHeight: '20px'
  });

  export const ContentTypeIcon = cssClass(cssPrefix, 'content-type-icon', {
    height: '100%',
    marginRight: 6,
    verticalAlign: 'top',
  });

  export const MetadataValue = cssClass(cssPrefix, 'metadata-value', {
    marginLeft: TabStyles.Spacing.MediumSpace
  });

  export const MetadataRelatedList = cssClass(cssPrefix, 'metadata-list', textEllipsis, {
    display: 'flex',
    flexDirection:'column',
    flexGrow: 1,
    minWidth: 0
  });

  export const metadataLineHeight = 20;

  export const MetadataLinkValueStyle: React.CSSProperties = {
    marginLeft: TabStyles.Spacing.MediumSpace,
    lineHeight: metadataLineHeight + 'px'
  };

  export const MetadataLinkValue = cssClass(cssPrefix, 'metadata-link-value', textEllipsis, {
    ...MetadataLinkValueStyle
  });

  export const MetadataLinks = cssClass(cssPrefix, 'metadata-value', {
    display: 'inline-block',
    marginRight: TabStyles.Spacing.DefaultSpace
  });

  const MetadataValueMultilineStyle: Style = {
    whiteSpace: 'normal',
    lineHeight: '1.5em',
  };

  const MetadataTextMultilineStyle: Style = {
    ...MetadataValueMultilineStyle,
    marginTop: TabStyles.Spacing.DefaultSpace,
  };

  const MetadataLinksMultilineStyle: Style = {
    ...MetadataValueMultilineStyle,
    marginTop: TabStyles.Spacing.MediumSpace,
  };

  export const MetadataValueContentDescription = cssClass(cssPrefix, 'metadata-content-description',
    MetadataValueMultilineStyle);

  export const MetadataTextDescription = cssClass(cssPrefix, 'metadata-text-description',
    MetadataTextMultilineStyle);

  export const MetadataLinksDescription = cssClass(cssPrefix, 'metadata-links-description',
    MetadataLinksMultilineStyle);

  export const RecommendationUsernameAdjust = cssClass(cssPrefix, 'recommendation-username-adjust', {
    marginTop: TabStyles.Spacing.DefaultSpace
  });

  export const SharedWithMeContentDescription = cssClass(cssPrefix, 'shared-with-me-content-description', {
    ...MetadataValueMultilineStyle,
    wordBreak: 'break-word',
  });

  export const SharedWithMeMetadata = cssClass(cssPrefix, 'shared-with-me-metadata', {
    display: 'flex',
    lineHeight: '1.5em',
    margin: '20px 0px',
    wordBreak: 'break-word',
  });
}
